/* eslint-disable jsx-a11y/label-has-associated-control */
import React  from 'react';     
import { Dropdown } from 'primereact/dropdown'; 

const FieldDropdown =  (props) => {
    
    const onChange = (value) => {  
        if (props.onChange !== null){
            props.onChange(value);
        } 
    }  

    const isFormFieldInValid = (name) => !!(typeof(props.errors) !== 'undefined' && props.errors !== null && props.errors[name]);
    
    const getFormErrorMessage = (name) => {  
        return isFormFieldInValid(name) && <small className="p-error">{props.errors[name].message}</small>;
    };
    
    const isFilled = props.value !== null && props.value !== undefined;

    if(typeof(props.showClear) !== 'undefined'  && !props.showClear)
    {
      return (
        <>  
          <span className="p-float-label">
            <Dropdown  
              value={props.value} 
              options={props.options}  
              optionValue={props.optionValue}
              optionLabel={props.optionLabel}
              onChange={onChange}
              className={`${props.className} ${isFilled ? 'p-inputwrapper-filled' : ''} ${isFormFieldInValid(props.name) ? 'p-invalid' : ''}`}
              placeholder={props.placeholder}
              filter={props.options !==null ? (props.options.length !== null ? props.options.length > 30 : false) : false} 
              disabled={props.disabled}
              resetFilterOnHide={true}
              optionDisabled={props.optionDisabled}
            />
            <label className={isFormFieldInValid(props.name) === true ? 'p-error' : ''}>{props.label}</label>
          </span>
          { getFormErrorMessage(props.name) } 
        
        </>
        );
    }
      return (  
        <>  
          <span className="p-float-label">
            <Dropdown  
              value={props.value} 
              options={props.options}  
              optionValue={props.optionValue}
              optionLabel={props.optionLabel}
              onChange={onChange}
              className={`${props.className} ${isFilled ? 'p-inputwrapper-filled' : ''} ${isFormFieldInValid(props.name) ? 'p-invalid' : ''}`}
              placeholder={props.placeholder}
              filter={props.options !==null ? (props.options.length !== null ? props.options.length > 30 : false) : false} 
              showClear
              resetFilterOnHide={true}
              disabled={props.disabled}
              optionDisabled={props.optionDisabled}
            />
            <label className={isFormFieldInValid(props.name) === true ? 'p-error' : ''}>{props.label}</label>
          </span>
          { getFormErrorMessage(props.name) } 
        </> 
      )
}   
    
export default FieldDropdown; 
